import React, { useState, useEffect } from 'react';
import { Mail, User, MessageCircle, ChevronRight, X, Search , Contact } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
// import { Alert, AlertDescription } from '@/components/ui/alert';
import HeaderTitle from '../components/HeaderTitle';
const ContactForm = (props) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    selectedProducts: [],
    message: ''
  });

  const [products, setProducts] = useState([]);
  const [submitted, setSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [showProductDropdown, setShowProductDropdown] = useState(false);
  const location = useLocation();

  console.log(process.env.REACT_APP_SCRIPT_URL)
  useEffect(() => {
    // If product was selected from wishlist
    if (location.state?.selectedProduct) {
      setFormData(prev => ({
        ...prev,
        selectedProducts: [...prev.selectedProducts, location.state.selectedProduct]
      }));
    }
    
    // Load products from data.json
    const productsList = props.product?.map(p => (
    {
      id: p.id,
      name: p.name
    }
  )) || [];
    setProducts(productsList);
  }, [location]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleProductSelect = (product) => {
    if (!formData.selectedProducts.find(p => p.id === product.id)) {
      setFormData(prev => ({
        ...prev,
        selectedProducts: [...prev.selectedProducts, product]
      }));
    }
    setSearchTerm('');
    setShowProductDropdown(false);
  };

  const handleRemoveProduct = (productId) => {
    setFormData(prev => ({
      ...prev,
      selectedProducts: prev.selectedProducts.filter(p => p.id !== productId)
    }));
  };

  const filteredProducts = products.filter(product =>
    product.name.toLowerCase().includes(searchTerm.toLowerCase()) &&
    !formData.selectedProducts.find(p => p.id === product.id)
  );


  const handleSubmissionError = (error) => {
    console.error('Submission error:', error);
    alert('There was an error submitting your message. Please try again.');
  };

  const handleSubmissionSuccess = (result) => {
    setSubmitted(true);
    // Reset form
    setFormData({
      name: '',
      email: '',
      contact: '',
      selectedProducts: [],
      message: ''
    });
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
  
    try {
      const SCRIPT_URL = process.env.REACT_APP_SCRIPT_URL;
      
      // Prepare the form data
      console.log(formData)
      const payload = {
        name: formData.name,
        email: formData.email,
        contact: formData.mobile,
        selectedProducts: formData.selectedProducts.map(p => p.name).join(', '),
        message: formData.message
      };
  
      // Try the primary submission method first
      try {
        const response = await fetch(SCRIPT_URL, {
          redirect:'follow',
          method: 'POST',
          
          headers: {
            "Content-Type": "text/plain;charset=utf-8",
          },
          body: JSON.stringify(payload)
        });
  
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
  
        const result = await response.json();
        handleSubmissionSuccess(result);
      } catch (error) {
        // If primary method fails, try the fallback method
        console.log('Primary submission failed, trying fallback:', error);
        const result = await submitFormFallback(payload);
        handleSubmissionSuccess(result);
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      handleSubmissionError(error);
    } finally {
      setIsLoading(false);
    }
  };
  





  // Add a backup submission method using JSONP
  const submitFormFallback = (payload) => {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      const callbackName = 'callback_' + Math.random().toString(36).substr(2, 9);
      
      // Create global callback
      window[callbackName] = (response) => {
        delete window[callbackName];
        document.body.removeChild(script);
        resolve(response);
      };
  
      // Add error handling for the script
      script.onerror = () => {
        delete window[callbackName];
        document.body.removeChild(script);
        reject(new Error('Script failed to load'));
      };
  
      // Convert payload to URL parameters
      const params = new URLSearchParams();
      Object.entries(payload).forEach(([key, value]) => {
        params.append(key, value);
      });
      params.append('callback', callbackName);
  
      // Set script source with parameters
      script.src = `${process.env.REACT_APP_SCRIPT_URL}?${params.toString()}`;
      
      // Add script to document
      document.body.appendChild(script);
      
      // Add timeout to prevent hanging
      setTimeout(() => {
        if (window[callbackName]) {
          delete window[callbackName];
          document.body.removeChild(script);
          reject(new Error('Request timed out'));
        }
      }, 10000); // 10 second timeout
    });
  };
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Breadcrumb */
      }
      <HeaderTitle title={"Contact Us"}/>
      <nav className="mx-auto max-w-screen-xl px-2 py-2 sm:px-1 sm:py-2 lg:px-8" aria-label="Breadcrumb">
        <ol className="flex items-center gap-1 text-sm text-gray-600">
          <li>
            <Link to={'/'} className="block transition hover:text-gray-700">
              <span className="sr-only">Home</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="size-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                />
              </svg>
            </Link>
          </li>

          <li className="rtl:rotate-180">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="size-4"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                clipRule="evenodd"
              />
            </svg>
          </li>

          <li>
            <span className="text-gray-900 font-medium">Contact Us</span>
          </li>
        </ol>
      </nav>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">


        <div className="max-w-7xl mx-auto py-8">
          <div className="bg-white shadow-lg rounded-lg overflow-hidden">
            {!submitted ? (
              <div className="p-8">
                <form onSubmit={handleSubmit} className="space-y-6">
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
                    <div className="relative">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <User className="h-5 w-5 text-gray-400" />
                      </div>
                      <input
                        type="text"
                        name="name"
                        required
                        value={formData.name}
                        onChange={handleChange}
                        placeholder="Your Name"
                        className="pl-10 w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />
                    </div>

                    <div className="relative">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <Mail className="h-5 w-5 text-gray-400" />
                      </div>
                      <input
                        type="email"
                        name="email"
                        required
                        value={formData.email}
                        onChange={handleChange}
                        placeholder="Your Email"
                        className="pl-10 w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />
                    </div>
                    <div className="relative">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <Contact className="h-5 w-5 text-gray-400" />
                      </div>
                      <input
                        type="tel"
                        name="mobile"
                        required
                        value={formData.contact}
                        onChange={handleChange}
                        placeholder="Contact Number"
                        className="pl-10 w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />
                    </div>
                  </div>

                  {/* Product Selection */}
                  <div className="space-y-4">
                    <label className="block text-sm font-medium text-gray-700">
                      Select Products
                    </label>
                    
                    {/* Selected Products */}
                    <div className="flex flex-wrap gap-2 mb-4">
                      {formData.selectedProducts.map((product) => (
                        <div
                          key={product.id}
                          className="inline-flex items-center gap-2 bg-blue-50 text-blue-700 px-3 py-1 rounded-full text-sm"
                        >
                          {product.name}
                          <button
                            type="button"
                            onClick={() => handleRemoveProduct(product.id)}
                            className="hover:text-blue-900"
                          >
                            <X className="h-4 w-4" />
                          </button>
                        </div>
                      ))}
                    </div>

                    {/* Product Search */}
                    <div className="relative">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <Search className="h-5 w-5 text-gray-400" />
                      </div>
                      <input
                        type="text"
                        value={searchTerm}
                        onChange={(e) => {
                          setSearchTerm(e.target.value);
                          setShowProductDropdown(true);
                        }}
                        onFocus={() => setShowProductDropdown(true)}
                        placeholder="Search for products..."
                        className="pl-10 w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />
                      
                      {/* Product Dropdown */}
                      {showProductDropdown && searchTerm && (
                        <div className="absolute z-10 w-full mt-1 bg-white shadow-lg rounded-md border border-gray-200 max-h-60 overflow-auto">
                          {filteredProducts.length > 0 ? (
                            filteredProducts.map((product) => (
                              <button
                                key={product.id}
                                type="button"
                                onClick={() => handleProductSelect(product)}
                                className="w-full text-left px-4 py-2 hover:bg-gray-100 focus:outline-none"
                              >
                                {product.name}
                              </button>
                            ))
                          ) : (
                            <div className="px-4 py-2 text-gray-500">
                              No products found
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-3 pt-3 pointer-events-none">
                      <MessageCircle className="h-5 w-5 text-gray-400" />
                    </div>
                    <textarea
                      name="message"
                      required
                      value={formData.message}
                      onChange={handleChange}
                      placeholder="Your Message"
                      rows="4"
                      className="pl-10 w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>

                  <button
                    type="submit"
                    disabled={isLoading}
                    className="w-full bg-blue-500 text-white py-3 rounded-md hover:bg-blue-600 transition duration-300 ease-in-out transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {isLoading ? 'Sending...' : 'Send Message'}
                  </button>
                </form>
              </div>
            ) : (
              <div className="text-center p-8">
                <h2 className="text-3xl font-bold text-green-600 mb-4">
                  Thank You!
                </h2>
                <p className="text-gray-700 mb-6">
                  Your message has been submitted successfully. We'll get back to you soon.
                </p>
                <button
                  onClick={() => {
                    setSubmitted(false);
                    setFormData({
                      name: '',
                      email: '',
                      selectedProducts: [],
                      message: ''
                    });
                  }}
                  className="bg-blue-500 text-white px-6 py-3 rounded-md hover:bg-blue-600 transition duration-300"
                >
                  Send Another Message
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;